"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParagraphsAlias = exports.getTypographyColor = void 0;
var getTypographyColor = function (_a, brand) {
    var colors = _a.colors;
    switch (brand) {
        case 'valtra':
            return colors.grays[800];
        case 'agco':
            return colors.primary.black;
        default:
            return colors.primary.grays[800];
    }
};
exports.getTypographyColor = getTypographyColor;
var getParagraphsAlias = function (globals, brand) {
    var _a = globals.fonts.secondary, regular = _a.regular, bold = _a.bold;
    return {
        fontFamily: {
            bodyRegular: regular,
            bodyBold: bold,
            caption: bold,
            footer: regular,
        },
        color: (0, exports.getTypographyColor)(globals, brand),
    };
};
exports.getParagraphsAlias = getParagraphsAlias;
